import(/* webpackMode: "eager", webpackExports: ["ClientInit"] */ "/home/runner/work/baysgaia-site/baysgaia-site/src/components/atoms/ClientInit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientProviders"] */ "/home/runner/work/baysgaia-site/baysgaia-site/src/components/atoms/ClientProviders.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/baysgaia-site/baysgaia-site/src/components/organisms/global/Footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header","default"] */ "/home/runner/work/baysgaia-site/baysgaia-site/src/components/organisms/global/Header/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/baysgaia-site/baysgaia-site/src/styles/globals.scss");
